import React from 'react';
import PropTypes from 'prop-types';
import RequiredDocumentGeneralDataContainer from './generalData/RequiredDocumentGeneralDataContainer';

const RequiredDocumentContainer = ({ id, onChangeRequiredDocumentTitle, onRedirect }) => {
  return (
    <RequiredDocumentGeneralDataContainer id={id} onChangeRequiredDocumentTitle={onChangeRequiredDocumentTitle} onRedirect={onRedirect} />
  );
};

RequiredDocumentContainer.propTypes = {
  id: PropTypes.number,
  onChangeRequiredDocumentTitle: PropTypes.func,
  onRedirect: PropTypes.func
};

export default RequiredDocumentContainer;
